import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { CalcBox } from './calc-box.model';
import { FormattingService } from '@vwd/ngx-i18n';

@Component({
  selector: 'calc-box',
  templateUrl: './calc-box.component.html',
  styleUrls: ['./calc-box.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CalcBoxComponent implements OnChanges {
  @Input() cleanPrice: number;

  @Input() expectedYield: number;

  @Input() settingsError: boolean;

  cleanPriceOriginal: number;

  expectedYieldOriginal: number;

  changed: boolean;

  @Output() calcChanged = new EventEmitter<CalcBox>();

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.expectedYield) {
      this.expectedYield = this.expectedYieldOriginal = changes.expectedYield.currentValue;
    }

    if (changes.cleanPrice) {
      this.cleanPrice = this.cleanPriceOriginal = changes.cleanPrice.currentValue;
    }

    this.changed = false;

  }

  constructor(private formattingService: FormattingService,) { }


  changeCalc(value: any, optName: string) {



    let calc: CalcBox;
    const parsedValue = this.formattingService.parseFloat(value);

    if (optName === 'cleanPrice') {

      this.cleanPrice = parsedValue;
      // no consider comments
      // calc = this.changed ? new CalcBox(0, parsedValue) : new CalcBox(0, this.cleanPriceOriginal);
      calc =  new CalcBox(0, parsedValue);
    } else {

      this.expectedYield = parsedValue;
      // no consider comments
      // calc = this.changed ? new CalcBox(parsedValue, 0) : new CalcBox(this.expectedYieldOriginal, 0);
      calc =  new CalcBox(parsedValue, 0);
    }

    this.calcChanged.emit(calc);
  }

}
